var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"banner__footer"},[_c('img',{attrs:{"src":require("../../assets/icons/icon-list.svg"),"alt":"icon lab","title":"icon lab","height":"40px"}}),_c('p',[_vm._v(" Vivimos para acercarte a cada oportunidad que un emprendedor debería tener para potenciar su negocio. ")])])])
}]

export { render, staticRenderFns }